import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';

import Error from '@/pages/_error';
import CMSPage from '@/src/cms/components/CMSPage';
import request from '@/utils/axios';
import searchNewsReleases, { getNewReleaseId } from '@/utils/searchNewsReleases';

const NewsRelease = props => {
  const router = useRouter();
  const { releaseData } = props;
  const [pageData, setPageData] = useState(null);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);

  const { query, asPath } = router;
  const _sitepageid = query.slug || getNewReleaseId(asPath);

  useEffect(() => {
    if (!_sitepageid) return;
    (async function mounted() {
      try {
        setLoading(true);
        const response = await request({
          url: `cms/newsrelease`,
          params: {
            sitePageId: _sitepageid,
          },
        });
        const { data } = response;
        if (data.Success === 'false' || data.AvailableToWeb === 'N') {
          setError(true);
        } else if (!releaseData || data.DateLastUpdated !== releaseData.DateLastUpdated) {
          setPageData(data);
        }
        setLoading(false);
      } catch (err) {
        setError(true);
        setLoading(false);
      }
    })();
  }, [_sitepageid]);

  if (error) {
    return <Error status={404} />;
  }

  return (
    <CMSPage
      loading={loading}
      data={pageData || releaseData || {}}
      type="newsrelease"
      path={`/press/news-release/release/${_sitepageid}`}
    />
  );
};

export async function getStaticPaths() {
  const response = await searchNewsReleases();
  const { results } = response;
  return {
    paths: results.map(r => ({ params: { slug: r.SitePageId.toString() } })),
    fallback: false,
  };
}

export async function getStaticProps({ params }) {
  try {
    const sitePageId = params.slug;
    if (!sitePageId) {
      return {
        props: {
          releaseData: null,
        },
      };
    }
    const response = await request({
      url: `cms/newsrelease`,
      params: {
        sitePageId,
      },
    });
    const { data } = response;
    if (data.AvailableToWeb === 'N') {
      return {
        props: {
          releaseData: null,
        },
      };
    }
    return {
      props: {
        releaseData: data.Success === 'false' ? null : data,
      },
    };
  } catch (e) {
    return {
      props: {
        releaseData: null,
      },
    };
  }
}

export default NewsRelease;
